/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
import { useState } from 'react';
import { FaEdit, FaExclamationCircle, FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import ReactTooltip from 'react-tooltip';
import Select from '../../../../components/select';
import { getMyWriters, getSocieties } from '../../../../api/queries';
import ButtonPrimaryText from '../../../../components/buttonPrimaryText';
// import Input from '../../../../components/input';
import LoadingSmall from '../../../../components/loadingSmall';
import HR from '../../../../components/hr';
import { strToBool } from '../../../../helpers/helpers';
import AppState from '../../../../store/appstate';
import NumericalInput from '../../../../components/numericalInput';
import RebrandButtonLink from '../../../../components/rebrandButtonLink';
import useSiteConfigAuth from '../../../../api/sanity/queries/getSiteConfigWithCode';
import SubModal from '../../../../components/SubModal';
import WritersForm from '../writers/writersForm';
import getColours from '../../../../helpers/getColours';

function SongWriterSplitCreateRow({
  writer, setWriterSplitField, i, deleteSongWriter, updateWorkEtag,
}) {
  const flags = useFlags();
  const reskinFlag = flags['publishing-dashboard-reskin'];
  const { t } = useTranslation('songs');
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const writers = getMyWriters({ aac: selectedAccount });
  const societies = getSocieties();
  const { data: siteConfig } = useSiteConfigAuth();
  const isTunecore = siteConfig?.display_name === 'TuneCore';
  const textColor = isTunecore ? 'black' : 'white';
  const { highlightColour } = getColours();
  const backgroundColor = isTunecore ? '#00ef86' : highlightColour;

  const [selectedWriterId, setSelectedWriterId] = useState(null);
  const [editWriterModalIsOpen, setEditWriterModalIsOpen] = useState(false);

  const designationCodes = [
    { name: t('songs:author-option'), value: 1 },
    { name: t('songs:composer-option'), value: 2 },
    { name: t('songs:both-option'), value: 3 },
  ];

  if (!writers.isSuccess || !societies.isSuccess) {
    return (<LoadingSmall />);
  }

  const writerDetails = writers.data.writers.find((w) => w.writercode === writer.writercode);
  const society = societies.data.societies.find((s) => s.cisaccode === writerDetails?.societycisaccode);
  const writerType = designationCodes.find((d) => d.value === parseInt(writer?.writerdesignationcode));

  const writerUpdate = (writerData) => {
    updateWorkEtag();
    setWriterSplitField({ writercode: writer.writercode, field: 'writer', x: writerData });
  };

  if (writer.isdeleted) {
    return <></>;
  }

  return (
    <>

      <SubModal openSubPortal={editWriterModalIsOpen} closeSubPortal={setEditWriterModalIsOpen}>
        <WritersForm id={selectedWriterId} modal closeForm={setEditWriterModalIsOpen} writerUpdate={writerUpdate} />
      </SubModal>

      <div className={`flex flex-wrap items-center p-6 ${isTunecore && reskinFlag ? 'bg-tunecore-mid-grey' : ''}`}>
        {reskinFlag ? (
          <div className="w-full mb-2 lg:w-2/12 lg:mb-0">
            <h2 className={`text-sm ${isTunecore ? 'text-white' : 'text-black'}`}>
              {writerDetails?.firstname}
              {' '}
              {writerDetails?.middlename}
              {' '}
              {writerDetails?.lastname}
            </h2>
          </div>
        ) : (
          <div className="w-full mb-2 lg:w-2/12 lg:mb-0">
            <h2 className="text-base font-semibold text-old-sentric-table-text">
              {writerDetails?.firstname}
              {' '}
              {writerDetails?.middlename}
              {' '}
              {writerDetails?.lastname}
            </h2>
          </div>
        )}
        <div className="w-full mb-2 lg:w-2/12 lg:mb-0">
            {society?.name === '' || !society?.name ? (
              !isTunecore && (
                <>
                  <FaExclamationCircle
                    className="max-w-md"
                    data-tip={t('songs:membership-tooltip')}
                    data-for="exclamationTooltip"
                  />
                  <ReactTooltip id="exclamationTooltip"
                    type="warning"
                    effect="solid"
                    textColor={textColor} backgroundColor={backgroundColor} />
                </>
              )
            ) : (
            reskinFlag ? (
                <p className={`text-xs ${isTunecore ? 'text-white' : 'text-sentric-rebrand-grey-text font-sentric-alt'}`}>
                {t('songs:membership')}:{' '}
                {society?.name}
                <br />
                CAE / IPI #:{' '}
                <span style={{ display: 'inline' }}>
                  {writerDetails?.caeipinumber ? writerDetails.caeipinumber : '-'}
                </span>
                {writerDetails?.publishername && (
                  <>
                    <br />
                    {t('songs:publisher')}:{' '}
                    {writerDetails.publishername}
                  </>
                )}
              </p>
            ) : (
              <p className="text-xs font-semibold">
                {t('songs:membership')}:{' '}
                {society?.name}
                <br />
                CAE / IPI #:{' '}
                {writerDetails?.caeipinumber ? writerDetails.caeipinumber : '-'}
                {writerDetails?.publishername && (
                  <>
                    <br />
                    {t('songs:publisher')}:{' '}
                    {writerDetails.publishername}
                  </>
                )}
              </p>
            )
          )}
        </div>
        <div className="w-full mb-2 lg:w-2/12 lg:mb-0">
          <Select
            list
            showLabel={false}
            id={`btnSongWriterSplitRole_${i}`}
            className={`select-search select-grey-bg w-full lg:pr-4 ${reskinFlag
              ? 'font-sentric-alt text-base text-black'
              : 'text-old-sentric-dark-gray'
              }`}
            name="writerdesignationcode"
            placeholder={t('songs:select-role')}
            value={writerType?.value}
            onChange={(selected) => setWriterSplitField({ writercode: writer.writercode, field: 'writerdesignationcode', x: selected })}
            options={[
              // { name: 'Unknown', value: 0 },
              { name: t('songs:author-option'), value: 1 },
              { name: t('songs:composer-option'), value: 2 },
              { name: t('songs:both-option'), value: 3 },
            ]}
          />
        </div>
        <div className="flex flex-wrap items-center justify-between w-full gap-3 text-sm lg:w-6/12 md:flex-nowrap">
          <div className="w-full lg:w-28">
            <NumericalInput
              className="numerical-input-grey-bg"
              id={`btnSongWriterSplitPercent_${i}`}
              min="0"
              max="100"
              type="number"
              placeholder="%"
              isPercentage
              value={writer?.writershare}
              onKeyDown={(e) => {
                if (e.keyCode === 69 || e.keyCode === 107
                  || e.keyCode === 187 || e.keyCode === 109 || e.keyCode === 189) {
                  e.preventDefault();
                }
              }}
              onChange={(e) => setWriterSplitField({ writercode: writer.writercode, field: 'writershare', x: e.target.value })}
              onBlur={(e) => setWriterSplitField({ writercode: writer.writercode, field: 'writershare', x: parseFloat(e.target.value).toFixed(2) })}
            />
          </div>
          <div className="w-full mt-2 lg:w-48 md:mt-0">
            <div className="flex items-center">
              <input
                style={{
                  accentColor: highlightColour,
                }}
                data-tip
                data-for="tipregistertocollect"
                type="checkbox"
                id={`righttocollect_${i}`}
                name={`righttocollect${i}`}
                checked={strToBool(writer?.righttocollect)}
                className={`mr-4  ${isTunecore ? 'text-tunecore-blue' : ''}`}
                onChange={(e) => {
                  setWriterSplitField({ writercode: writer.writercode, field: 'righttocollect', x: e.target.value });
                  setWriterSplitField({ writercode: writer.writercode, field: 'writer', x: writerDetails });
                }}
              />
              <label className="text-xs font-semibold" htmlFor={`righttocollect${i}`}>
                {t('songs:right-to-collect')}
              </label>
            </div>
            <ReactTooltip id="tipregistertocollect" className="max-w-md" place="right" type="warning" effect="solid" multiline="true" textColor={textColor} backgroundColor={backgroundColor}>
              <center className="font-bold">
                {t('songs:right-to-collect-tooltip')}
              </center>
            </ReactTooltip>
          </div>
          <div className="mt-2 md:mt-0">
            {reskinFlag ? (
              <RebrandButtonLink
                smallfont
                onClick={() => {
                    setSelectedWriterId(writer.writercode);
                    setEditWriterModalIsOpen(true);
                }}
              >
                <FaEdit className="visible inline-block mr-2 md:invisible lg:visible" size={16} />
                {t('songs:edit-writer')}
              </RebrandButtonLink>
            ) : (
              <ButtonPrimaryText
                onClick={() => {
                    setSelectedWriterId(writer.writercode);
                    setEditWriterModalIsOpen(true);
                }}
              >
                <FaEdit className="visible inline-block mr-2 md:invisible lg:visible" size={16} />
                {t('songs:edit-writer')}
              </ButtonPrimaryText>
            )}
          </div>
            {reskinFlag ? (
              <RebrandButtonLink
                smallfont
                id={`btnSongWriterSplitremove_${i}`}
                onClick={() => deleteSongWriter(writer.writercode)}
              >
                <FaTimes className="ml-1" size={20} />
              </RebrandButtonLink>
            ) : (
              // eslint-disable-next-line jsx-a11y/control-has-associated-label
              <button type="button" id={`btnSongWriterSplitremove_${i}`} className="text-sentric-rebrand-orange hover:text-black" onClick={() => deleteSongWriter(writer.writercode)}><FaTimes size={20}/></button>
            )}
        </div>
      </div>
      <div className="px-6">
        <HR />
      </div>
    </>
  );
}

export default SongWriterSplitCreateRow;